// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LQm9","left":"styles_left__394XV","desktopActions":"styles_desktopActions__296sz","title":"styles_title__1C8uh"};